import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  token: '',
  dispatchCodes: [],
  allDispatchCodes: [],
  totalPages: 0,
  totalRecords: 0,
  dispatchCode: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_21: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_DispatchCodes(state, dispatchCodes) {
    state.dispatchCodes = dispatchCodes.items;
    state.totalPages = dispatchCodes.totalPages;
    state.totalRecords = dispatchCodes?.totalRecords ?? 0;
  },
  SET_AllDispatchCodes(state, dispatchCodes) {
    state.allDispatchCodes = dispatchCodes;
  },
  SET_DispatchCode(state, dispatchCode) {
    state.dispatchCode = dispatchCode;
  },
};
const actions = {
  errorDispatchCode({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllDispatchCodes({ commit, dispatch, rootState }) {
    return apiClient
      .get('/DispatchCodes/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllDispatchCodes', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDispatchCode', error);
      });
  },
  addDispatchCode({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/DispatchCodes', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDispatchCode', error);
      });
  },
  getDispatchCode({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/DispatchCodes/ById?dispatchCodeId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DispatchCode', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDispatchCode', error);
      });
  },
  editDispatchCode({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/DispatchCodes/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDispatchCode', error);
      });
  },
  deleteDispatchCode({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/DispatchCodes/Remove?dispatchCodeId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDispatchCode', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
